import React, { useEffect, useState } from 'react';
import "./DescriptionList.css";

const DescriptionList = ({ classes, onSelectClass, onSelectAll, allSelected, selectedMap }) => {

  const handleSelectAllChange = (e) => {
    const checked = e.target.checked;
    onSelectAll(checked);
    console.log("checked", checked);
  };

  return (
    <div className="description-list-container">
      <table>
        <thead>
          <tr>
            <th><input type="checkbox" checked={allSelected} onChange={handleSelectAllChange} /></th>
            <th>ID</th>
            <th>名称</th>
            <th>高峰/低峰</th>
            <th>价格</th>
            <th>类型</th>
          </tr>
        </thead>
        <tbody>
        {classes.map((cls, index) => {
            const key = `${cls.id}-${cls.is_peak}-${cls.price}`;
            return (
              <tr key={key}> {/* Combine multiple columns to form a unique key */}
                <td><input type="checkbox" checked={selectedMap[key] || false} onChange={(e) => onSelectClass(cls.id, cls.name, cls.is_peak, cls.price, cls.action, e.target.checked)} /></td>
                <td>{cls.id}</td>
                <td>{cls.name}</td>
                <td>{cls.is_peak ? '高峰' : '低峰'}</td>
                <td>{cls.price}</td>
                <td>{cls.category}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DescriptionList;
